"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encodeQueryValue = void 0;
const encodeQueryValue = input => input.replaceAll('%', '%25').replaceAll('+', '%2B').replaceAll(' ', '+').replaceAll('#', '%23').replaceAll('&', '%26').replaceAll('"', '%22').replaceAll("'", '%27').replaceAll('`', '%60').replaceAll('<', '%3C').replaceAll('>', '%3E')
// eslint-disable-next-line no-control-regex, unicorn/no-hex-escape -- This is intentional to encode control characters
.replaceAll(/[\x00-\x1F]/g, char => encodeURIComponent(char));
exports.encodeQueryValue = encodeQueryValue;
